import React, { useState } from "react"
import { Input, Container, Form, FormGroup, Alert } from "reactstrap"
import validateInput from "../../view/shared/validations/phoneVerify"
import { createBrowserHistory } from "history"
import { Trans, useLingui } from "@lingui/react"
import "react-phone-number-input/style.css"
import "react-phone-input-2/lib/style.css"
import ar from "react-phone-input-2/lang/ar.json"
import PhoneInput from "react-phone-input-2"
import { AuthAPI } from "../../store/api"
import { t } from "@lingui/macro"

const history = createBrowserHistory({ forceRefresh: true })

const PhoneVerify = () => {
  const { i18n } = useLingui()

  const [state, setState] = useState({
    phone_number: "",
    isLoaded: false,
    errors: {},
    bounce: "",
    lang: i18n.locale,
    buttonDisable: false,
  })
  const [_country] = React.useState(localStorage.getItem("_country") || "GH")

  const isValid = () => {
    const { errors, isValid } = validateInput(state)
    if (!isValid) {
      setState({ ...state, errors })
    }
    return isValid
  }

  const onSubmit = (e) => {
    e.preventDefault()
    if (isValid()) {
      setState({ ...state, buttonDisable: true })
      sendVerifcation(state.phone_number).then(
        () =>
          history.push({
            pathname: "/VerifyCode",
          }),
        (error) => {
          const { response } = error
          if (!response.data) {
            return
          }
          setState({
            ...state,
            bounce:
              response.data.message ===
                "Error sending code. Contact hiveonline for support"
                ? t({
                  id: "Error sending code. Contact hiveonline for support",
                })
                : response.data.message,
            buttonDisable: false,
          })
        },
      )
    } else {
      setState({ ...state, phone_number: "" })
    }
  }

  const phoneValidate = (phone) => {
    if (phone === "+") {
      return ""
    } else {
      return phone
    }
  }

  const sendVerifcation = async (phone_number) => {
    const phone = phoneValidate("+" + phone_number)
    await AuthAPI.post(`/forgot-pin?lan=${i18n.locale}&app=vsla`, {
      phoneNumber: phone,
    })
  }

  const login_email = t({ id: "Phone number" })
  const submit = t({ id: "Submit" })
  const { errors, bounce } = state

  const inputStyle = {
    flex: "10",
    fontFamily: "Fira Sans",
    height: "50px",
    width: "100%",
    fontSize: "20px",
  }

  return (
    <div>
      <Container>
        <Alert color="secondary" style={loadingStyle}>
          <Trans id="phone.verify.message" />
        </Alert>

        <Form onSubmit={onSubmit}>
          {bounce && <div className="alert alert-danger">{bounce}</div>}
          <span style={{ color: "red" }}>{errors.phone_number}</span>
          <FormGroup
            style={{
              direction: "ltr",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <PhoneInput
              country={_country.toLocaleLowerCase()}
              enableSearch
              disableSearchIcon
              placeholder={login_email}
              inputStyle={inputStyle}
              style={loadingStyle}
              value={state.phone_number}
              onChange={(phone_number) => setState({ ...state, phone_number })}
              limitMaxLength={true}
              localization={i18n.locale === "ar" ? ar : false}
            />
          </FormGroup>
          <FormGroup>
            <Input
              type="submit"
              value={submit}
              name="submit"
              className="btn btn-primary"
              size="lg"
            />
          </FormGroup>
        </Form>
      </Container>
    </div>
  )
}

const loadingStyle = {
  fontFamily: "Fira Sans",
  fontSize: "18px",
}

export default PhoneVerify
